import React from "react";
import NavbarTop from "../../componets/AdminComponents/Navbar/NavbarTop";
import Sidebar from "../../componets/AdminComponents/Navbar/Sidebar";

const Navbar = () => {
  return (
    <div>
      <NavbarTop />
      <Sidebar />
    </div>
  );
};

export default Navbar;
